import { NavigateBackLink } from '@exam-management/components';
import { QuestionCreationTaskCreationFormLogic } from '@exam-management/question-creation-task-creation';
import { Flex, PageHeader } from '@shared/components';

export default function QuestionCreationTaskCreationPage() {
  return (
    <Flex sx={{ flexDirection: 'column' }}>
      <PageHeader
        title='Create Task: Question Creation'
        linkAdornment={<NavigateBackLink to='/task-management/question-creation' />}
      />
      <Flex
        sx={(theme) => ({ flexDirection: 'column', p: theme.spacing(6), gap: theme.spacing(6) })}
      >
        <QuestionCreationTaskCreationFormLogic />
      </Flex>
    </Flex>
  );
}
